import React from "react";
import { Directory } from "../components/Directory";
import { Header } from "../components/Header";

function ContactList() {
  return (
    <>
      <Header />
      <Directory />
    </>
  );
}

export default ContactList;
